import { createContext } from "react";

import { IConfirmModalProps } from "@amphore-dev/amphore-lib";

import { TTask } from "@/types";

type TModalState =
	| { type: "idle"; props?: Record<string, never> }
	| {
			type: "unsavedChanges";
			props: Omit<IConfirmModalProps, "open" | "onClose">;
	  }
	| {
			type: "deleteTasksConfirm";
			props: { onConfirm: () => void; items: TTask[] };
	  }
	| {
			type: "archiveConfirm";
			props: {
				onConfirm: () => void;
				kind: "project" | "view";
				name: string;
			};
	  };

export type { TModalState };

export interface IModalContext {
	openModal: (modal: TModalState) => void;
	closeModal: () => void;
	modal: TModalState | null;
}

export const ModalContext = createContext<IModalContext | null>(null);
